module.exports = __webpack_public_path__ + "static/media/navbar-home.50d0a314.png";